import { LOGIN_SUCCESS, LOGIN_FAIL } from '../actions/actionTypes';

interface Success { success: boolean | null };
interface Action { type: string };

const initState: Success = {
  success: null
};

export default function authReducer(state: Success = initState, action: Action) {

  switch (action.type) {
      
    case LOGIN_SUCCESS:
      return  { success: true };
    case LOGIN_FAIL:
      return { success: false }; 
    default:
      return state;
  }
}